import { createContext } from 'react';

export type SymbolContextState = {
  sendEmoji: (emoji: string) => void;
  sendSticker: (url: string) => void;
};

export const SymbolContext = createContext<SymbolContextState>({} as SymbolContextState);
